module.exports = __webpack_public_path__ + "img/radio-city.a0337a8e.png";